module.exports = __webpack_public_path__ + "static/img/baguettewoman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/baguettewoman.jpg
// module id = J71z
// module chunks = 1